import SelectedProductSizesTableItem from './SelectedProductSizesTableItem';

export default SelectedProductSizesTableItem;
